import { useCallback, useEffect, useState } from 'react';

declare global {
  interface Window {
    __ucCmp?: { showSecondLayer: () => void };
  }
}

const UC_INITIALIZED_EVENT = 'UC_UI_INITIALIZED';

/**
 * Tracks availability of the Usercentrics CMP, which is injected asynchronously via GTM.
 * `isAvailable` stays false when GTM/Usercentrics is not configured or blocked.
 */
export function useUsercentrics() {
  const [isAvailable, setIsAvailable] = useState(() => !!window.__ucCmp);

  useEffect(() => {
    if (isAvailable) {
      return;
    }

    const handleInitialized = () => setIsAvailable(!!window.__ucCmp);

    // Re-check in case the CMP finished loading between render and effect subscription.
    handleInitialized();
    window.addEventListener(UC_INITIALIZED_EVENT, handleInitialized);

    return () => {
      window.removeEventListener(UC_INITIALIZED_EVENT, handleInitialized);
    };
  }, [isAvailable]);

  // Opens the consent settings so users can review or withdraw consent (GDPR).
  const showPrivacySettings = useCallback(() => {
    window.__ucCmp?.showSecondLayer();
  }, []);

  return { isAvailable, showPrivacySettings };
}
